module.exports = __webpack_public_path__ + "img/david.13bc2a54.png";